import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme, Box, CircularProgress } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import logoPainel from './imagens/logopainelftm.png.ico';
import Login from './components/Login';
import Register from './components/Register';
import Layout from './components/Layout';
import Dashboard from './components/Dashboard';
import ConfiguracoesSite from './components/ConfiguracoesSite';
import AdminLayout from './components/AdminLayout';
import AdminDashboard from './pages/AdminDashboard';
import AdminUsers from './components/AdminPanel';
import PrivateRoute from './components/PrivateRoute';
import axios from 'axios';
import MeusSites from './components/MeusSites';
import ComprarTokens from './components/ComprarTokens';
import AdminVendas from './pages/AdminVendas';
import LandingPage from './pages/LandingPage';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import ContaConfiguracoes from './pages/ContaConfiguracoes';
import FtmIA from './pages/FtmIA';
import ConfigurarDominio from './pages/ConfigurarDominio';
import VideoAulas from './pages/VideoAulas';
import DuvidasFrequentes from './pages/DuvidasFrequentes';
import MeusEmails from './pages/MeusEmails';
import AdminTopClientes from './pages/AdminTopClientes';
import AdminBroadcast from './pages/AdminBroadcast';
import DominioProprio from './pages/DominioProprio';
import NumeroVirtual from './pages/NumeroVirtual';
import FtmLegacy from './pages/FtmLegacy';
import CloudflareSites from './pages/CloudflareSites';
import AgendarVerificacao from './pages/AgendarVerificacao';
import AdminAgendamentos from './pages/AdminAgendamentos';
import CriarVerificaix from './pages/CriarVerificaix';
import CriarVerificaixV2 from './pages/CriarVerificaixV2';
import Gringa from './pages/Gringa';
import IndiqueGanhe from './pages/IndiqueGanhe';
import AdminAfiliados from './pages/AdminAfiliados';
import PageViewTracker from './utils/PageViewTracker';
import CookieConsent from './components/CookieConsent';
import PoliticaPrivacidade from './pages/PoliticaPrivacidade';
import TermosUso from './pages/TermosUso';
import Checkout from './pages/Checkout';
const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: '#7C3AED' },
    secondary: { main: '#10B981' },
    background: { default: '#0B0F1A', paper: '#141926' },
    text: { primary: '#E5E7EB', secondary: '#9CA3AF', disabled: '#6B7280' },
  },
  typography: {
    fontFamily: '"Plus Jakarta Sans", "DM Sans", sans-serif',
    h4: { fontSize: '1.65rem', fontWeight: 700, letterSpacing: '-0.02em' },
    h5: { fontSize: '1.35rem', fontWeight: 700, letterSpacing: '-0.01em' },
    h6: { fontSize: '1.1rem', fontWeight: 600 },
    body1: { fontFamily: '"DM Sans", sans-serif' },
    body2: { fontFamily: '"DM Sans", sans-serif', color: '#9CA3AF' },
    button: { fontFamily: '"Plus Jakarta Sans", sans-serif', fontWeight: 600 },
  },
  shape: { borderRadius: 10 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { textTransform: 'none', borderRadius: 8, fontWeight: 600, fontSize: '0.875rem' },
        containedPrimary: {
          backgroundColor: '#7C3AED',
          '&:hover': { backgroundColor: '#6D28D9' },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: { borderRadius: 12, backgroundImage: 'none', border: '1px solid rgba(255,255,255,0.06)' },
      },
    },
    MuiTextField: {
      defaultProps: { variant: 'outlined', fullWidth: true },
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            backgroundColor: 'rgba(11, 15, 26, 0.5)',
            borderRadius: 8,
            '& fieldset': { borderColor: 'rgba(255,255,255,0.08)' },
            '&:hover fieldset': { borderColor: 'rgba(255,255,255,0.15)' },
            '&.Mui-focused fieldset': { borderColor: '#7C3AED' },
          },
          '& .MuiInputLabel-root': { color: 'rgba(255,255,255,0.4)' },
          '& .MuiInputLabel-root.Mui-focused': { color: '#7C3AED' },
          '& .MuiOutlinedInput-input': { color: '#E5E7EB' },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(11, 15, 26, 0.5)',
          borderRadius: 8,
          '& fieldset': { borderColor: 'rgba(255,255,255,0.08)' },
          '&:hover fieldset': { borderColor: 'rgba(255,255,255,0.15)' },
          '&.Mui-focused fieldset': { borderColor: '#7C3AED' },
        },
        input: { color: '#E5E7EB' },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: { color: 'rgba(255,255,255,0.4)', '&.Mui-focused': { color: '#7C3AED' } },
      },
    },
    MuiTableContainer: {
      styleOverrides: { root: { borderRadius: 10, overflowX: 'auto' } },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          '& .MuiTableCell-head': {
            backgroundColor: 'rgba(255,255,255,0.03)',
            color: '#9CA3AF',
            fontWeight: 600,
            fontSize: '0.75rem',
            textTransform: 'uppercase',
            letterSpacing: '0.06em',
            borderBottom: '1px solid rgba(255,255,255,0.06)',
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: { borderBottom: '1px solid rgba(255,255,255,0.04)', color: '#D1D5DB', padding: '12px 16px' },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: { '&:hover': { backgroundColor: 'rgba(255,255,255,0.02) !important' } },
      },
    },
    MuiChip: {
      styleOverrides: { root: { borderRadius: 6, fontWeight: 600 } },
    },
    MuiAlert: {
      styleOverrides: { root: { borderRadius: 8 } },
    },
    MuiCard: {
      styleOverrides: { root: { borderRadius: 12, backgroundImage: 'none' } },
    },
    MuiDialog: {
      styleOverrides: { paper: { borderRadius: 12, backgroundImage: 'none', border: '1px solid rgba(255,255,255,0.06)' } },
    },
    MuiSelect: {
      styleOverrides: { icon: { color: 'rgba(255,255,255,0.4)' } },
    },
    MuiCssBaseline: {
      styleOverrides: {
        '@keyframes fadeIn': {
          from: { opacity: 0, transform: 'translateY(6px)' },
          to: { opacity: 1, transform: 'translateY(0)' },
        },
        '.fade-in': { animation: 'fadeIn 0.3s ease-out' },
      },
    },
    MuiPaginationItem: {
      styleOverrides: {
        root: {
          color: '#9CA3AF',
          '&.Mui-selected': { backgroundColor: 'rgba(124, 58, 237, 0.15)', color: '#A78BFA', '&:hover': { backgroundColor: 'rgba(124, 58, 237, 0.25)' } },
        },
      },
    },
  },
});

axios.defaults.withCredentials = true;
axios.defaults.timeout = 15000;

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const savedToken = localStorage.getItem('token');
        const savedUser = localStorage.getItem('user');

        if (!savedToken || !savedUser) {
          setLoading(false);
          return;
        }

        try {
          const parsed = JSON.parse(savedUser);
          setUser(parsed);
          setIsAuthenticated(true);
          setLoading(false);
        } catch {
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          setLoading(false);
          return;
        }

        try {
          const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/auth/check`, {
            headers: { Authorization: `Bearer ${savedToken}` },
            timeout: 8000
          });
          if (response.data.authenticated) {
            setUser(response.data.user);
            localStorage.setItem('user', JSON.stringify(response.data.user));
          } else {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            setIsAuthenticated(false);
            setUser(null);
          }
        } catch {
          // Servidor indisponível, mas usuário já está carregado do localStorage
        }
      } catch (error) {
        console.error('Erro ao verificar autenticação:', error);
        setIsAuthenticated(false);
        setUser(null);
        setLoading(false);
      }
    };

    checkAuth();
  }, []);

  const handleLogin = async (userData) => {
    setUser(userData);
    setIsAuthenticated(true);
  };

  const handleLogout = async () => {
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/logout`);
    } catch (error) {
      // Continua com logout mesmo se o servidor falhar
    } finally {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      setUser(null);
      setIsAuthenticated(false);
    }
  };

  if (loading) {
    return (
      <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', background: '#111827', gap: 3 }}>
        <img src={logoPainel} alt="Painel FTM" style={{ width: 56, height: 56, borderRadius: 12 }} />
        <CircularProgress size={32} sx={{ color: '#7C3AED' }} />
      </Box>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <PageViewTracker />
        <Routes>
          <Route 
            path="/login" 
            element={
              !isAuthenticated ? (
                <Login onLogin={handleLogin} />
              ) : (
                <Navigate to="/dashboard" replace />
              )
            } 
          />
          <Route 
            path="/register" 
            element={
              !isAuthenticated ? (
                <Register onLogin={handleLogin} />
              ) : (
                <Navigate to="/dashboard" replace />
              )
            } 
          />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <Layout onLogout={handleLogout}>
                  <Dashboard user={user} onLogout={handleLogout} />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/configuracoes-site"
            element={
              <PrivateRoute>
                <Layout>
                  <ConfiguracoesSite />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/configuracoes-site/:siteId"
            element={
              <PrivateRoute>
                <Layout>
                  <ConfiguracoesSite />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <PrivateRoute>
                <AdminLayout>
                  <AdminDashboard />
                </AdminLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/admin-ftm"
            element={
              <PrivateRoute>
                <AdminLayout>
                  <AdminUsers />
                </AdminLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/admin-ftm/vendas"
            element={
              <PrivateRoute>
                <AdminLayout>
                  <AdminVendas />
                </AdminLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/admin-ftm/afiliados"
            element={
              <PrivateRoute>
                <AdminLayout>
                  <AdminAfiliados />
                </AdminLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/admin-ftm/top-clientes"
            element={
              <PrivateRoute>
                <AdminLayout>
                  <AdminTopClientes />
                </AdminLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/admin-ftm/broadcast"
            element={
              <PrivateRoute>
                <AdminLayout>
                  <AdminBroadcast />
                </AdminLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/admin-ftm/agendamentos"
            element={
              <PrivateRoute>
                <AdminLayout>
                  <AdminAgendamentos />
                </AdminLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/meus-sites"
            element={
              <PrivateRoute>
                <Layout>
                  <MeusSites />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route path="/comprar-tokens" element={<PrivateRoute><Layout><ComprarTokens /></Layout></PrivateRoute>} />
          <Route path="/checkout/:orderId" element={<PrivateRoute><Checkout /></PrivateRoute>} />
          <Route path="/minha-conta" element={<PrivateRoute><Layout><ContaConfiguracoes /></Layout></PrivateRoute>} />
          <Route path="/ftm-ia" element={<PrivateRoute><Layout><FtmIA /></Layout></PrivateRoute>} />
          <Route path="/configurar-dominio" element={<PrivateRoute><Layout><ConfigurarDominio /></Layout></PrivateRoute>} />
          <Route path="/video-aulas" element={<PrivateRoute><Layout><VideoAulas /></Layout></PrivateRoute>} />
          <Route path="/duvidas-frequentes" element={<PrivateRoute><Layout><DuvidasFrequentes /></Layout></PrivateRoute>} />
          <Route path="/meus-emails" element={<PrivateRoute><Layout><MeusEmails /></Layout></PrivateRoute>} />
          <Route path="/dominio-proprio" element={<PrivateRoute><Layout><DominioProprio /></Layout></PrivateRoute>} />
          <Route path="/numero-virtual" element={<PrivateRoute><Layout><NumeroVirtual /></Layout></PrivateRoute>} />
          <Route path="/ftm-legacy" element={<PrivateRoute><Layout><FtmLegacy /></Layout></PrivateRoute>} />
          <Route path="/cloudflare-sites" element={<PrivateRoute><Layout><CloudflareSites /></Layout></PrivateRoute>} />
          <Route path="/agendar-verificacao" element={<PrivateRoute><Layout><AgendarVerificacao /></Layout></PrivateRoute>} />
          <Route path="/criar-verificaix" element={<PrivateRoute><Layout><CriarVerificaix /></Layout></PrivateRoute>} />
          <Route path="/criar-verificaix-v2" element={<PrivateRoute><Layout><CriarVerificaixV2 /></Layout></PrivateRoute>} />
          <Route path="/gringa" element={<PrivateRoute><Layout><Gringa /></Layout></PrivateRoute>} />
          <Route path="/indique-ganhe" element={<PrivateRoute><Layout><IndiqueGanhe /></Layout></PrivateRoute>} />
          <Route path="/forgot-password" element={!isAuthenticated ? <ForgotPassword /> : <Navigate to="/dashboard" replace />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route path="/politica-de-privacidade" element={<PoliticaPrivacidade />} />
          <Route path="/termos-de-uso" element={<TermosUso />} />
          <Route path="/" element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <LandingPage />} />
        </Routes>
        <CookieConsent />
      </Router>
    </ThemeProvider>
  );
}

export default App;
